<template>
    <div class="modal is-active">
        <div class="modal-background" @click.stop="confirmClose" />
        <div class="modal-content" @click.stop="confirmClose">
            <object-card
                :is-creation="true"
                :model="contentModel"
                :content="draft"
                :data-macy-complete="true"
                :has-location="hasLocation"
                @addElement="$emit('add-element', $event)"
                @save="updateOrCreateObject"
                @delete="$emit('delete-object', draft._id)"
            />
        </div>
    </div>
</template>

<script>
import ObjectCard from '@/components/ObjectCard';
import { isEmptyObject } from '@/lib/helpers';
import _ from 'underscore';
export default {
    components: {
        ObjectCard,
    },
    props: {
        draft: {
            type: Object,
            default() {
                return {};
            },
        },
        hasLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            draftCopy: {},
        };
    },
    computed: {
        projectType() {
            return this.$store.getters.project.type;
        },
        projectMode() {
            return this.$store.getters.project.mode;
        },
        contentModel() {
            if (this.projectType === 'trivial') {
                return {
                    title: { type: String },
                    related: [{ name: 'answers', type: Array }],
                    media: [
                        { name: 'images', type: Array },
                        { name: 'files', type: Array },
                        { name: 'tags', type: Array },
                        { name: 'url', type: String },
                        { name: 'audio', type: String },
                        { name: 'video', type: String },
                        { name: 'draw', type: String },
                        { name: 'location', type: String },
                        { name: 'embed', type: String },
                    ],
                };
            } else {
                return {
                    title: { type: String },
                    description: { type: String },
                    media: [
                        { name: 'images', type: Array },
                        { name: 'files', type: Array },
                        { name: 'tags', type: Array },
                        { name: 'url', type: String },
                        { name: 'audio', type: String },
                        { name: 'video', type: String },
                        { name: 'draw', type: String },
                        { name: 'location', type: String },
                        { name: 'embed', type: String },
                    ],
                };
            }
        },
    },
    mounted() {
        this.draftCopy = _.clone(this.draft);
    },
    methods: {
        confirmClose() {
            if (
                !isEmptyObject(_.omit(this.draft, '_id', 'order', 'owner')) &&
                !_.isEqual(this.draftCopy, this.draft)
            ) {
                if (confirm(this.$t('project.discard_unsaved_changes'))) {
                    this.$emit('close');
                }
            } else {
                this.$emit('close');
            }
        },
        async updateOrCreateObject() {
            if (!this.draft.location && this.projectMode == 'map') {
                return confirm(this.$t('missing_location_message'));
            }
            if (this.draft._id == 'draft') {
                return this.$emit('create-object');
            } else {
                return this.$emit('update-object');
            }
        },
    },
};
</script>

<style></style>
